import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../../entries/common/request";
import { BaseApi } from "../../core/base-api";
import { makeMethod, makeDataMethod } from "../../core/base-api/methods-maker";
export var MeProfileApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(MeProfileApi, _BaseApi);

  var _super = _createSuper(MeProfileApi);

  function MeProfileApi() {
    _classCallCheck(this, MeProfileApi);

    return _super.apply(this, arguments);
  }

  return MeProfileApi;
}(BaseApi);
/**
 * current logged in user info
 */

MeProfileApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Me.Profile.Paths.Show,
  needAuth: true
});
/**
 * Update user profile
 */

MeProfileApi.prototype.update = makeDataMethod({
  method: 'put',
  path: Request.Me.Profile.Paths.Update,
  needAuth: true
});
/**
 * update profile image
 */

MeProfileApi.prototype.updateImage = makeDataMethod({
  method: 'post',
  path: Request.Me.Profile.Paths.UpdateImage,
  needAuth: true
});
MeProfileApi.prototype.updatePin = makeDataMethod({
  method: 'post',
  path: Request.Me.Profile.Paths.UpdatePin,
  needAuth: true
});
MeProfileApi.prototype.SendPinReset = makeDataMethod({
  method: 'post',
  path: Request.Me.Profile.Paths.SendPinReset,
  needAuth: true
});
MeProfileApi.prototype.resetPin = makeDataMethod({
  method: 'post',
  path: Request.Me.Profile.Paths.ResetPin,
  needAuth: true
});